import React, { useRef, useState } from 'react';
import { Check } from 'lucide-react';
import LandingButton from './LandingButton';
import LandingSection from './LandingSection';
import Reveal from './Reveal';
import ArrowCursor from './ArrowCursor';
import StarBorderGlow from './StarBorderGlow';
import { SIGNUP_URL } from './urls';
import { useT } from './i18n';

const LandingPricing = () => {
  const t = useT();
  const included = t('pricing.included');
  const zoneRef = useRef(null);
  const ctaRef = useRef(null);
  const [ctaActive, setCtaActive] = useState(false);

  return (
    <LandingSection id="cennik" variant="white">
      <div className="landing-pricing-zone" ref={zoneRef}>
      <div className="landing-container landing-pricing-zone__inner">
      <Reveal>
        <h2 className="landing-h2 landing-mb-lg" style={{ textAlign: 'center' }}>{t('pricing.title')}</h2>
      </Reveal>

      <Reveal delay={1}>
        <div className="landing-pricing-glow">
        <div className="landing-pricing-card">
          <span className="landing-pricing-card__badge">{t('pricing.badge')}</span>
          <div className="landing-pricing-card__price">
            1,90&nbsp;€
            <span className="landing-pricing-card__price-unit"> {t('pricing.priceUnit')}</span>
          </div>
          <ul className="landing-pricing-card__list">
            {included.map((item) => (
              <li key={item}>
                <Check size={18} strokeWidth={2.5} aria-hidden />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <span ref={ctaRef} className="landing-pricing-cta-target">
            <StarBorderGlow active={ctaActive}>
              <LandingButton variant="primary" size="lg" href={SIGNUP_URL}>
                {t('pricing.cta')}
              </LandingButton>
            </StarBorderGlow>
          </span>
          <p className="landing-pricing-card__note">
            {t('pricing.note')}
          </p>
        </div>
        </div>
      </Reveal>
      </div>

      <ArrowCursor zoneRef={zoneRef} targetRef={ctaRef} onNear={setCtaActive} nearRadius={120} />
      </div>
    </LandingSection>
  );
};

export default LandingPricing;
